import Base from './Base';

class Plaid extends Base {
  async createPlaidLinkToken() {
    const response = await this.apiClient.post('/plaid/create-link-token');

    return response.data;
  }

  async updatePlaidLinkToken(payload: { id: number }) {
    const response = await this.apiClient.post('/plaid/update-link-token', payload);

    return response.data;
  }

  async exchangePublicToken(payload: { publicToken: string }) {
    const response = await this.apiClient.post('/plaid/exchange-public-token', payload);

    return response.data;
  }

  async getConnections() {
    const response = await this.apiClient.get('/plaid/connections');

    return response.data;
  }
}

export default Plaid;
